var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonStack = function SvgButtonStack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11.67 11.65",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "button_stack")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.28,4.32.4,4.4,5.55,7.67a.5.5,0,0,0,.29.09.65.65,0,0,0,.3-.09Q8.75,6,11.38,4.33a.5.5,0,0,0,0-.9L6.17.11a.56.56,0,0,0-.66,0L1.6,2.6.27,3.44A.49.49,0,0,0,.28,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.37,7.31,10.1,6.5a.24.24,0,0,0-.32,0l-3.13,2A1.43,1.43,0,0,1,5,8.48l-3.14-2a.23.23,0,0,0-.28,0l-1.3.83a.49.49,0,0,0,0,.9l5.21,3.32a.56.56,0,0,0,.65,0l3.6-2.29,1.63-1a.53.53,0,0,0,.28-.44A.55.55,0,0,0,11.37,7.31Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonStack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button_stack.112de2b8.svg";
export { ForwardRef as ReactComponent };